import * as HttpService from "../../../../service/HttpService";

/**
 * 获取用电单位下拉列表
 */
export const gteElectricityUnit = () => {
    return HttpService.post(HttpService.DOMAIN + "/defectiveWorkOrder/gteElectricityUnit","");
};

/**
 * 查询工单列表
 */
export const queryWorkOrdersList = (data) => {
    return HttpService.post(HttpService.DOMAIN + "/defectiveWorkOrder/queryWorkOrdersList",data);
};

/**
 * 查询设备信息
 */
export const queryEquipmentList = (data) => {
    return HttpService.post(HttpService.DOMAIN + "/defectiveWorkOrder/queryEquipmentList",data);
};

/**
 * 新增工单
 */
export const addDefectWorkOrder = (data) => {
    return HttpService.post(HttpService.DOMAIN + "/defectiveWorkOrder/addDefectWorkOrder",data);
};

/**
 * 获取人员树
 */
export const getPeopleTree = (data) => {
    return HttpService.post(HttpService.DOMAIN + "/defectiveWorkOrder/getPeopleTree",data);
};

/**
 * 获取设备树信息
 */
export const getDeviceTree = (data) => {
    return HttpService.post(HttpService.DOMAIN + "/defectiveWorkOrder/getDeviceTree",data);
};

/**
 * 新增处理工单
 */
export const editDefectWorkOrder = (data) => {
    return HttpService.post(HttpService.DOMAIN + "/defectiveWorkOrder/editDefectWorkOrder",data);
};

/**
 * 新增验收信息
 */
export const editExamineWorkOrder = (data) => {
    return HttpService.post(HttpService.DOMAIN + "/defectiveWorkOrder/editExamineWorkOrder",data);
};

/**
 * 删除工单
 */
export const deleteExamineWorkOrde = (data) => {
    return HttpService.post(HttpService.DOMAIN + "/defectiveWorkOrder/deleteExamineWorkOrde",data);
};

/**
 * 更新工单
 */
export const editWorkOrder = (data) => {
    return HttpService.post(HttpService.DOMAIN + "/defectiveWorkOrder/editWorkOrder",data);
};

/**
 * 更新工单
 */
export const gteElectricity = (data) => {
    return HttpService.post(HttpService.DOMAIN + "/defectiveWorkOrder/gteElectricity",data);
};



/**
 * 统计
 */
export const gteDefectStatistics = (data) => {
    return HttpService.post(HttpService.DOMAIN+'/defectStatistics/gteDefectStatistics',data);
};

/**
 * 统计
 */
export const getDeficiency = (data) => {
    return HttpService.post(HttpService.DOMAIN+'/defectStatistics/getDeficiency',data);
};



















